import React from 'react';
import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import { Alert } from 'react-bootstrap';
import ServicesContext from '../../contexts/ServicesContext';
import { LensCuttingMachineIntegrationFile } from '../../models/LensCuttingMachineIntegrationFile';
import { LensCuttingMachineIntegrationStatus } from '../../enums/LensCuttingMachineIntegrationStatus';
import { strings } from '../../resources/strings';
import { lensCuttingMachineIntegrationStatusMapping } from '../../resources/lensCuttingMachineIntegrationResources';
import { WaitingIcon } from '../../common-components/WaitingIcon/WaitingIcon';
import { Button } from '../../common-components/Button/Button';
import { Table } from '../../common-components/Table/Table';
import { FooterContent } from './styles';

interface IModalManageLensCuttingIntegrationProps {
  orderId?: number;
  orderNumber?: string;
  close: () => void;
}

const ModalManageLensCuttingIntegration: React.FC<IModalManageLensCuttingIntegrationProps> = ({
  orderId,
  orderNumber,
  close
}) => {

  const [lensCuttingMachineIntegrationFileList, setLensCuttingMachineIntegrationFileList] = React.useState<LensCuttingMachineIntegrationFile[]>([]);
  const [loading, setLoading] = React.useState<boolean>(true);

  const {
    toastService,
    alertService,
    getLensCuttingMachineIntegrationFileByOrderService,
    generateLensCuttingMachineIntegrationFileService
  } = React.useContext(ServicesContext);

  React.useEffect(() => {
    getLensCuttingMachineIntegrationFileByOrder();
  }, [orderId]);

  return (
    <Modal
      size="lg"
      show={true}
      onHide={() => clickCloseModal()}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton style={{ height: '50px' }}>
        <Modal.Title>
          Integração com Cortadora de Lente {orderNumber}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body id='modalManageLensCuttingIntegration' style={{ maxHeight: '78vh', overflowY: 'auto' }}>
        {loading ? <WaitingIcon /> : (
          <div>
            {lensCuttingMachineIntegrationFileList.length > 0 ? (
              <Table>
                <thead>
                  <tr>
                    <th style={{ width: '25%' }}>Data</th>
                    <th style={{ width: '20%' }}>Vinculação</th>
                    <th style={{ width: '20%' }}>Receita</th>
                    <th style={{ width: '35%' }}>Detalhes</th>
                  </tr>
                </thead>
                <tbody>
                  {lensCuttingMachineIntegrationFileList.map((item) => {
                    return (
                      <tr key={`lens-cutting-machine-integration-file-${item.id}`}>
                        <td>{moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss')}</td>
                        <td>{item.productRecipeLinkingRequestId}</td>
                        <td>{item.customerRecipeId}</td>
                        <td>
                          {item.lastStatusDate
                            ? <div style={{ fontSize: '0.8em', color: 'gray' }}>
                              {moment(item.lastStatusDate).format('DD/MM/YYYY HH:mm:ss')}
                            </div> : null }
                          {lensCuttingMachineIntegrationStatusMapping[item.integrationStatus]}
                          {item.integrationDetails && item.integrationDetails != lensCuttingMachineIntegrationStatusMapping[item.integrationStatus]
                            ? <div>{item.integrationDetails}</div> : null}
                          {item.integrationStatus === LensCuttingMachineIntegrationStatus.Integrated
                            ? <div style={{ fontSize: '0.8em', color: 'gray' }}>
                              {item.fileName}
                            </div> : null }
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            ) : (
              <Alert variant='warning' style={{ marginBottom: '0px' }}>
                Nenhuma integração encontrada.
              </Alert>
            )}
          </div>
        )}
      </Modal.Body>

      {loading ? null : (
        <Modal.Footer>
          <FooterContent>
            <Button text='Atualizar' click={() => getLensCuttingMachineIntegrationFileByOrder()} marginRight='10px' />
            <Button text='Realizar Integração' click={() => generateLensCuttingMachineIntegrationFile()} />
          </FooterContent>
        </Modal.Footer>
      )}
    </Modal>
  );

  function clickCloseModal() {
    close();
  }

  function getLensCuttingMachineIntegrationFileByOrder() {
    if (!orderId) return;
    setLoading(true);
    getLensCuttingMachineIntegrationFileByOrderService.handle(orderId)
      .then((result) => {
        setLensCuttingMachineIntegrationFileList(result?.value?.list || []);
      })
      .catch(() => {
        toastService.warning(strings.OpsSomethingWrongGettingTheData);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function generateLensCuttingMachineIntegrationFile() {
    if (!orderId) return;
    setLoading(true);
    generateLensCuttingMachineIntegrationFileService.handle(orderId)
      .then((result) => {
        if (result?.value?.errorMessage) {
          alertService.warning(result?.value?.errorMessage);
          return;
        }
        getLensCuttingMachineIntegrationFileByOrder();
      })
      .catch(() => {
        toastService.warning(strings.OpsSomethingWrongSendTheData);
      })
      .finally(() => {
        setLoading(false);
      });
  }
}

export { ModalManageLensCuttingIntegration };